<app-excel-review-modal
  [title]="'parts.modals.reviewExcel.title' | transloco"
  [subtitle]="'parts.modals.reviewExcel.subtitle' | transloco"
  [items]="items"
  [(selected)]="selected"
  [isLoading]="isLoading"
  [isImporting]="isImporting"
  [canImport]="canImport"
  [importLabel]="'parts.modals.reviewExcel.importLabel' | transloco"
  [serverErrors]="serverErrors"
  [searchPlaceholder]="'parts.modals.reviewExcel.searchPlaceholder' | transloco"
  [matchesSearch]="matchesSearch"
  [entityLabel]="'parts.modals.reviewExcel.entityLabel' | transloco"
  [itemName]="itemName"
  [deleteWarningMessage]="'parts.modals.reviewExcel.deleteWarning' | transloco"
  [headerTemplate]="headerTemplate"
  [rowTemplate]="rowTemplate"
  [detailTemplate]="detailTemplate"
  [columnCount]="16"
  [emptyText]="'parts.modals.reviewExcel.emptyText' | transloco"
  [detailEmptyText]="'parts.modals.reviewExcel.detailEmptyText' | transloco"
  (itemRemoved)="onItemRemoved()"
  (applySuggestions)="onApplySuggestionsAsync($event)"
  (importRequested)="importAsync()"
  (closeRequested)="close()">
</app-excel-review-modal>

<ng-template #headerTemplate>
  <th>{{ 'parts.modals.fields.partName' | transloco }}</th>
  <th>{{ 'parts.modals.fields.oemNumber' | transloco }}</th>
  <th>{{ 'parts.modals.fields.make' | transloco }}</th>
  <th>{{ 'parts.modals.fields.model' | transloco }}</th>
  <th>{{ 'parts.modals.fields.modelYear' | transloco }}</th>
  <th>{{ 'parts.modals.fields.description' | transloco }}</th>
  <th>{{ 'parts.modals.fields.partType' | transloco }}</th>
  <th>{{ 'parts.modals.fields.category' | transloco }}</th>
  <th>{{ 'parts.modals.fields.storageLocation' | transloco }}</th>
  <th>{{ 'parts.modals.fields.reorderPoint' | transloco }}</th>
  <th>{{ 'parts.modals.fields.reorderQuantity' | transloco }}</th>
  <th>{{ 'parts.modals.fields.maximumQuantity' | transloco }}</th>
  <th>{{ 'parts.modals.fields.onHand' | transloco }}</th>
  <th>{{ 'parts.modals.fields.unitCost' | transloco }}</th>
  <th>{{ 'parts.modals.fields.supplier' | transloco }}</th>
  <th>{{ 'parts.modals.fields.dateReceived' | transloco }}</th>
</ng-template>

<ng-template #rowTemplate let-item>
  <td><strong>{{ item.partName || '-' }}</strong></td>
  <td>{{ item.partNumber || '-' }}</td>
  <td>{{ item.make || '-' }}</td>
  <td>{{ item.model || '-' }}</td>
  <td>{{ item.modelYear || '-' }}</td>
  <td class="cell-truncate" [title]="item.description">{{ item.description || '-' }}</td>
  <td>{{ item.partType || '-' }}</td>
  <td>{{ item.category || '-' }}</td>
  <td>{{ item.storageLocation || '-' }}</td>
  <td>{{ item.reorderPoint || '-' }}</td>
  <td>{{ item.reorderQuantity || '-' }}</td>
  <td>{{ item.maximumQuantity || '-' }}</td>
  <td>{{ item.onHand || '-' }}</td>
  <td>{{ item.unitCost || '-' }}</td>
  <td>{{ item.supplier || '-' }}</td>
  <td>{{ item.dateReceived || '-' }}</td>
</ng-template>

<ng-template #detailTemplate let-selected>
  <div class="field-group">
    <label class="field-label">{{ 'parts.modals.fields.partName' | transloco }}<span class="required">*</span></label>
    <input class="field-input" type="text" [placeholder]="'parts.modals.placeholders.enterPartName' | transloco"
      [class.field-input--warning]="hasFieldError(selected, 'partName')"
      [ngModel]="selected.partName" (ngModelChange)="onFieldChanged('partName', $event)">
  </div>

  <div class="field-group">
    <label class="field-label">{{ 'parts.modals.fields.oemNo' | transloco }}<span class="required">*</span></label>
    <input class="field-input" type="text" [placeholder]="'parts.modals.placeholders.enterOemNumber' | transloco"
      [class.field-input--warning]="hasFieldError(selected, 'partNumber')"
      [ngModel]="selected.partNumber" (ngModelChange)="onFieldChanged('partNumber', $event)">
  </div>

  <div class="field-group">
    <label class="field-label">{{ 'parts.modals.fields.make' | transloco }}<span class="required">*</span></label>
    <div ngbDropdown #makeDropdown="ngbDropdown" [autoClose]="'outside'" class="field-dropdown">
      <button type="button" ngbDropdownToggle class="field-dropdown__toggle"
        [class.field-dropdown__toggle--placeholder]="!selected.make"
        [class.field-dropdown__toggle--warning]="hasFieldError(selected, 'make')">
        <span class="toggle-label">{{ selected.make || ('parts.modals.dropdown.selectMake' | transloco) }}</span>
        <i class="ph ph-caret-down lh-base"></i>
      </button>
      <div ngbDropdownMenu>
        <div class="dropdown-search">
          <input type="text" [placeholder]="'parts.modals.dropdown.searchMake' | transloco" [value]="makeSearchTerm"
            (input)="makeSearchTerm = $any($event.target).value" (click)="$event.stopPropagation()">
        </div>
        <div class="dropdown-scroll">
          @for(make of filteredMakes; track make.id) {
            <button type="button" class="btn btn-outline option" ngbDropdownItem (click)="selectMakeAsync(make); makeDropdown.close()">{{ make.name }}</button>
          } @empty {
            <div class="dropdown-empty">{{ 'parts.modals.dropdown.noMakesFound' | transloco }}</div>
          }
        </div>
      </div>
    </div>
  </div>

  <div class="field-group">
    <label class="field-label">{{ 'parts.modals.fields.model' | transloco }}<span class="required">*</span></label>
    <div ngbDropdown #modelDropdown="ngbDropdown" [autoClose]="'outside'" class="field-dropdown">
      <button type="button" ngbDropdownToggle class="field-dropdown__toggle"
        [disabled]="!knownMake(selected) || isLoadingModels(selected)"
        [class.field-dropdown__toggle--placeholder]="!selected.model"
        [class.field-dropdown__toggle--warning]="hasFieldError(selected, 'model')">
        <span class="toggle-label">{{ isLoadingModels(selected) ? ('parts.modals.dropdown.loadingModels' | transloco) : (selected.model || ('parts.modals.dropdown.selectModel' | transloco)) }}</span>
        <i class="ph ph-caret-down lh-base"></i>
      </button>
      <div ngbDropdownMenu>
        <div class="dropdown-search">
          <input type="text" [placeholder]="'parts.modals.dropdown.searchModel' | transloco" [value]="modelSearchTerm"
            (input)="modelSearchTerm = $any($event.target).value" (click)="$event.stopPropagation()">
        </div>
        <div class="dropdown-scroll">
          @for(model of filteredModels(selected); track model.id) {
            <button type="button" class="btn btn-outline option" ngbDropdownItem (click)="selectModel(model); modelDropdown.close()">{{ model.name }}</button>
          } @empty {
            <div class="dropdown-empty">{{ 'parts.modals.dropdown.noModelsFound' | transloco }}</div>
          }
        </div>
      </div>
    </div>
  </div>

  <div class="field-group">
    <label class="field-label">{{ 'parts.modals.fields.modelYear' | transloco }}<span class="required">*</span></label>
    <input class="field-input" type="number" min="1900" [placeholder]="'parts.modals.placeholders.enterModelYear' | transloco"
      [class.field-input--warning]="hasFieldError(selected, 'modelYear')"
      [ngModel]="selected.modelYear" (ngModelChange)="onFieldChanged('modelYear', $event)">
  </div>

  <div class="field-group">
    <label class="field-label">{{ 'parts.modals.fields.description' | transloco }}<span class="required">*</span></label>
    <input class="field-input" type="text" [placeholder]="'parts.modals.placeholders.writeShortDescription' | transloco"
      [class.field-input--warning]="hasFieldError(selected, 'description')"
      [ngModel]="selected.description" (ngModelChange)="onFieldChanged('description', $event)">
  </div>

  <div class="field-group">
    <label class="field-label">{{ 'parts.modals.fields.partType' | transloco }}<span class="required">*</span></label>
    <div ngbDropdown #partTypeDropdown="ngbDropdown" [autoClose]="'outside'" class="field-dropdown">
      <button type="button" ngbDropdownToggle class="field-dropdown__toggle"
        [class.field-dropdown__toggle--placeholder]="!selected.partType"
        [class.field-dropdown__toggle--warning]="hasFieldError(selected, 'partType')">
        <span class="toggle-label">{{ selected.partType || ('parts.modals.dropdown.selectPartType' | transloco) }}</span>
        <i class="ph ph-caret-down lh-base"></i>
      </button>
      <div ngbDropdownMenu>
        <div class="dropdown-search">
          <input type="text" [placeholder]="'parts.modals.dropdown.searchPartType' | transloco" [value]="partTypeSearchTerm"
            (input)="partTypeSearchTerm = $any($event.target).value" (click)="$event.stopPropagation()">
        </div>
        <div class="dropdown-scroll">
          @for(partType of filteredPartTypes; track partType.id) {
            <button type="button" class="btn btn-outline option" ngbDropdownItem (click)="selectPartType(partType); partTypeDropdown.close()">{{ partType.name }}</button>
          } @empty {
            <div class="dropdown-empty">{{ 'parts.modals.dropdown.noPartTypesFound' | transloco }}</div>
          }
        </div>
      </div>
    </div>
  </div>

  <div class="field-group">
    <label class="field-label">{{ 'parts.modals.fields.category' | transloco }}<span class="required">*</span></label>
    <div ngbDropdown class="field-dropdown">
      <button type="button" ngbDropdownToggle class="field-dropdown__toggle"
        [class.field-dropdown__toggle--placeholder]="!selected.category"
        [class.field-dropdown__toggle--warning]="hasFieldError(selected, 'category')">
        <span class="toggle-label">{{ selected.category || ('parts.modals.dropdown.selectCategory' | transloco) }}</span>
        <i class="ph ph-caret-down lh-base"></i>
      </button>
      <div ngbDropdownMenu>
        <div class="dropdown-scroll">
          @for(category of categories; track category.id) {
            <button type="button" class="btn btn-outline option" ngbDropdownItem (click)="selectCategory(category)">{{ category.name }}</button>
          } @empty {
            <div class="dropdown-empty">{{ 'parts.modals.dropdown.noCategoriesFound' | transloco }}</div>
          }
        </div>
      </div>
    </div>
  </div>

  <div class="field-group">
    <label class="field-label">{{ 'parts.modals.fields.storageLocation' | transloco }}<span class="required">*</span></label>
    <div ngbDropdown #storageDropdown="ngbDropdown" [autoClose]="'outside'" class="field-dropdown">
      <button type="button" ngbDropdownToggle class="field-dropdown__toggle" [disabled]="isRefreshingStorageLocations"
        [class.field-dropdown__toggle--placeholder]="!selected.storageLocation"
        [class.field-dropdown__toggle--warning]="hasFieldError(selected, 'storageLocation')">
        <span class="toggle-label">{{ selected.storageLocation || ('parts.modals.dropdown.selectStorageLocation' | transloco) }}</span>
        <i class="ph ph-caret-down lh-base"></i>
      </button>
      <div ngbDropdownMenu>
        <div class="dropdown-search">
          <input type="text" [placeholder]="'parts.modals.dropdown.searchStorageLocation' | transloco" [value]="storageLocationSearchTerm"
            (input)="storageLocationSearchTerm = $any($event.target).value" (click)="$event.stopPropagation()">
        </div>
        <div class="dropdown-scroll">
          @for(warehouse of filteredStorageLocations; track warehouse.id) {
            <button type="button" class="btn btn-outline option" ngbDropdownItem (click)="selectStorageLocation(warehouse); storageDropdown.close()">{{ warehouse.name }}</button>
          } @empty {
            <div class="dropdown-empty">{{ 'parts.modals.dropdown.noStorageLocationsFound' | transloco }}</div>
          }
        </div>
      </div>
    </div>
    <button type="button" class="add-link-btn" [disabled]="isRefreshingStorageLocations" (click)="openAddWarehouseModal()">
      @if(isRefreshingStorageLocations) {
        <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
        <span>{{ 'parts.modals.reviewExcel.refreshingWarehouses' | transloco }}</span>
      } @else {
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M12.6663 7.33301H8.66634V3.33301H7.33301V7.33301H3.33301V8.66634H7.33301V12.6663H8.66634V8.66634H12.6663V7.33301Z" fill="currentColor"/>
        </svg>
        <span>{{ 'parts.modals.reviewExcel.addNewWarehouse' | transloco }}</span>
      }
    </button>
  </div>

  <div class="field-group">
    <label class="field-label">{{ 'parts.modals.fields.reorderPoint' | transloco }}<span class="required">*</span></label>
    <input class="field-input" type="number" min="0" [placeholder]="'parts.modals.placeholders.enterReorderPoint' | transloco"
      [class.field-input--warning]="hasFieldError(selected, 'reorderPoint')"
      [ngModel]="selected.reorderPoint" (ngModelChange)="onFieldChanged('reorderPoint', $event)">
  </div>

  <div class="field-group">
    <label class="field-label">{{ 'parts.modals.fields.reorderQuantity' | transloco }}<span class="required">*</span></label>
    <input class="field-input" type="number" min="0" [placeholder]="'parts.modals.placeholders.enterReorderQuantity' | transloco"
      [class.field-input--warning]="hasFieldError(selected, 'reorderQuantity')"
      [ngModel]="selected.reorderQuantity" (ngModelChange)="onFieldChanged('reorderQuantity', $event)">
  </div>

  <div class="field-group">
    <label class="field-label">{{ 'parts.modals.fields.maxQuantity' | transloco }}<span class="required">*</span></label>
    <input class="field-input" type="number" min="0" [placeholder]="'parts.modals.placeholders.enterMaximumQuantity' | transloco"
      [class.field-input--warning]="hasFieldError(selected, 'maximumQuantity')"
      [ngModel]="selected.maximumQuantity" (ngModelChange)="onFieldChanged('maximumQuantity', $event)">
  </div>

  <div class="field-group">
    <label class="field-label">{{ 'parts.modals.fields.onHandLower' | transloco }}<span class="required">*</span></label>
    <input class="field-input" type="number" min="0" [placeholder]="'parts.modals.placeholders.enterQuantityOnHand' | transloco"
      [class.field-input--warning]="hasFieldError(selected, 'onHand')"
      [ngModel]="selected.onHand" (ngModelChange)="onFieldChanged('onHand', $event)">
  </div>

  <p class="field-note">{{ 'parts.modals.reviewExcel.openingStockNote' | transloco }}</p>

  <div class="field-group">
    <label class="field-label">{{ 'parts.modals.fields.unitCost' | transloco }}<span *ngIf="selectedHasOpeningStock" class="required">*</span></label>
    <input class="field-input" type="number" min="0" step="0.01" [placeholder]="'parts.modals.placeholders.costPerUnit' | transloco"
      [disabled]="!selectedHasOpeningStock"
      [class.field-input--warning]="hasFieldError(selected, 'unitCost')"
      [ngModel]="selected.unitCost" (ngModelChange)="onFieldChanged('unitCost', $event)">
  </div>

  <div class="field-group">
    <label class="field-label">{{ 'parts.modals.fields.supplier' | transloco }}<span *ngIf="selectedHasOpeningStock" class="required">*</span></label>
    <div ngbDropdown #supplierDropdown="ngbDropdown" [autoClose]="'outside'" class="field-dropdown">
      <button type="button" ngbDropdownToggle class="field-dropdown__toggle" [disabled]="!selectedHasOpeningStock || isRefreshingSuppliers"
        [class.field-dropdown__toggle--placeholder]="!selected.supplier"
        [class.field-dropdown__toggle--warning]="hasFieldError(selected, 'supplier')">
        <span class="toggle-label">{{ selected.supplier || ('parts.modals.dropdown.selectSupplier' | transloco) }}</span>
        <i class="ph ph-caret-down lh-base"></i>
      </button>
      <div ngbDropdownMenu>
        <div class="dropdown-search">
          <input type="text" [placeholder]="'parts.modals.dropdown.searchSupplier' | transloco" [value]="supplierSearchTerm"
            (input)="supplierSearchTerm = $any($event.target).value" (click)="$event.stopPropagation()">
        </div>
        <div class="dropdown-scroll">
          <button type="button" class="btn btn-outline option" ngbDropdownItem (click)="selectSupplier(null); supplierDropdown.close()">{{ 'parts.modals.dropdown.noSupplier' | transloco }}</button>
          @for(supplier of filteredSuppliers; track supplier.id) {
            <button type="button" class="btn btn-outline option" ngbDropdownItem (click)="selectSupplier(supplier); supplierDropdown.close()">{{ supplier.name }}</button>
          } @empty {
            <div class="dropdown-empty">{{ 'parts.modals.dropdown.noSuppliersFound' | transloco }}</div>
          }
        </div>
      </div>
    </div>
    <button type="button" class="add-link-btn" [disabled]="isRefreshingSuppliers" (click)="openAddSupplierModal()">
      @if(isRefreshingSuppliers) {
        <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
        <span>{{ 'parts.modals.reviewExcel.refreshingSuppliers' | transloco }}</span>
      } @else {
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M12.6663 7.33301H8.66634V3.33301H7.33301V7.33301H3.33301V8.66634H7.33301V12.6663H8.66634V8.66634H12.6663V7.33301Z" fill="currentColor"/>
        </svg>
        <span>{{ 'parts.modals.reviewExcel.addNewSupplier' | transloco }}</span>
      }
    </button>
  </div>

  <div class="field-group">
    <app-flatpickr-date-picker
      [label]="'parts.modals.fields.dateReceived' | transloco"
      [(value)]="selected.dateReceived"
      (valueChange)="onFieldChanged('dateReceived', $event ?? '')"
      [maxDate]="today"
      [dateFormat]="'Y-m-d'"
      [altFormat]="'d/m/Y'"
      [placeholder]="'dd/mm/yyyy'"
      [disabled]="!selectedHasOpeningStock"
      [required]="selectedHasOpeningStock">
    </app-flatpickr-date-picker>
  </div>

  <div class="callout callout--info">
    <i class="ph-fill ph-info"></i>
    <div>
      <strong>{{ 'parts.modals.reviewExcel.reorderAlertTitle' | transloco }}</strong>
      <div>{{ 'parts.modals.reviewExcel.reorderAlertText' | transloco }}</div>
    </div>
  </div>
</ng-template>
